export enum ApiOrderState {
    NEW = 'NEW',
    CANCELED = 'CANCELED',
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    PAYMENT_REVIEW = 'PAYMENT_REVIEW',
    PROCESSING = 'PROCESSING',
    COMPLETE = 'COMPLETE',
    CLOSED = 'CLOSED',
    HOLDED = 'HOLDED',
}

export interface GetOrderOrderItemResponse {
    id: string;
    sku: string;
    name: string;
    qty: number;
    qtyRefunded: number;
}

export interface GetOrderOrderResponse {
    shipping_address: {
        address_type: string;
        customer_address_id: number;
        email: string;
        entity_id: number;
        parent_id: number;
        prefix: string;
        city: string;
        country_id: string;
        firstname: string;
        lastname: string;
        postcode: string;
        street: Array<string>;
        telephone: string;
    };
    total_item_count?: number;
    items: {[key: string]: GetOrderOrderItemResponse};
    invoice_url: string;
    state: string;
    increment_id: string;
    uuid: string;
    invoice_uuid: string | null;
    created_at: string;
}

export interface GetOrderResponse {
    order: GetOrderOrderResponse;
}
